import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import BugReportOutlinedIcon from '@material-ui/icons/BugReportOutlined';
import SwapHorizontalCircleOutlinedIcon from '@material-ui/icons/SwapHorizontalCircleOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';
import {Link} from 'react-router-dom';

export default function PageTabs() {
  
  const styles = {
    tab: {
        color: '#000000'
    }
}

  return (
    <>
        <Tabs style={styles.tab} value={false} >
            <Tab to="/" component={Link} label="Tickets" icon={<ConfirmationNumberOutlinedIcon />}/>
            <Tab to="/Problems" component={Link} label="Problems" icon={<BugReportOutlinedIcon />} />
            <Tab to="/Changes" component={Link} label="Changes" icon={<SwapHorizontalCircleOutlinedIcon />} />
            <Tab to="/Dashboard" component={Link} label="Dashboard" icon={<DashboardIcon />} />
        </Tabs>
   </>
  );
}

 /* <Tab to="/Assets" component={Link} label="Assets" icon={<ImportantDevicesIcon />} /> */